import React, {useState} from 'react';
import {FormGroup, Switch} from '@blueprintjs/core';

interface BooleanInputProps {
  value: any;
  disabled: boolean;
  onChange: (value: any) => void;
}

const getLabel = (checked: boolean) => checked ? 'True' : 'False';

export const BooleanInput = ({
  value,
  disabled,
  onChange,
}: BooleanInputProps) => {
  const [checked, setChecked] = useState<boolean>(value === 1);

  const onValueChange = (event: any) => {
    onChange(event.target.checked ? 1 : 0);
    setChecked(event.target.checked);
  }

  return (
    <FormGroup label="">
      <Switch
        label={getLabel(checked)}
        className="boolean-input"
        defaultChecked={checked}
        onChange={onValueChange}
        disabled={disabled}
        inline={true}
      />
    </FormGroup>
  )
};
